export function getSavedGender(gendersList = [], gender = '') {
  const initialSavedGender = gendersList && gendersList?.find((o) => o.value === gender)?.label;

  return initialSavedGender || null;
}
